<template>
    <NDrawerContent>
        <div class="space-y-2 pt-2">
            <div class="text-base text-gray-900 p-2">
                <div>
                    {{ $page.props.user.name }}
                </div>
            </div>
        </div>
        <ul class="space-y-2 pb-2">
            <li class="flex">
                <Link
                    href="/dashboard"
                    class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                >
                    Dashboard
                </Link>
            </li>
            <li class="flex">
                <NCollapse>
                    <NCollapseItem
                        title="Envios"
                        name="envios"
                        class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                    >
                        <div class="flex flex-col">
                            <Link
                                href="/envios"
                                class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                            >
                                <div class="flex space-x-2">
                                    <Icon size="20">
                                        <Boxes class="text-gray-500" />
                                    </Icon>
                                    <span> Listado </span>
                                </div>
                            </Link>
                            <Link
                                href="/envios/crear"
                                class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                            >
                                <div class="flex space-x-2">
                                    <Icon size="20">
                                        <Plus class="text-gray-500" />
                                    </Icon>
                                    <span> Crear envio </span>
                                </div>
                            </Link>
                        </div>
                    </NCollapseItem>
                </NCollapse>
            </li>
            <li class="flex" v-if="$page.props.user.tipo === 'super_admin'">
                <Link
                    href="/clientes_globales"
                    class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                >
                    Clientes Globales
                </Link>
            </li>
            <li
                class="flex"
                v-if="
                    $page.props.user.tipo === 'super_admin' ||
                    $page.props.user.tipo === 'global_admin'
                "
            >
                <Link
                    href="/clientes"
                    class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                >
                    Clientes
                </Link>
            </li>
            <li
                class="flex"
                v-if="
                    $page.props.user.tipo === 'super_admin' ||
                    $page.props.user.tipo === 'global_admin' ||
                    $page.props.user.tipo === 'cliente_admin'
                "
            >
                <Link
                    href="/sucursales"
                    class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                >
                    Sucursales
                </Link>
            </li>
            <li
                class="flex"
                v-if="
                    $page.props.user.tipo === 'super_admin' ||
                    $page.props.user.tipo === 'global_admin'
                "
            >
                <Link
                    href="/usuarios"
                    class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                >
                    Usuarios
                </Link>
            </li>
            <li class="flex" v-if="$page.props.user.tipo === 'super_admin'">
                <Link
                    href="/proveedores"
                    class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                >
                    Proveedores
                </Link>
            </li>
            <li class="flex" v-if="$page.props.user.tipo === 'super_admin'">
                <NCollapse>
                    <NCollapseItem
                        title="Config"
                        name="config"
                        class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                    >
                        <div class="flex flex-col">
                            <Link
                                href="/parametros"
                                class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                            >
                                Parametros
                            </Link>
                            <Link
                                href="/cordones"
                                class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                            >
                                Cordones
                            </Link>
                            <Link
                                href="/sla_envios"
                                class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                            >
                                SLA
                            </Link>
                            <Link
                                href="/estados"
                                class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                            >
                                Estados
                            </Link>
                            <Link
                                href="/cps"
                                class="w-full text-gray-900 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                            >
                                Codigos Postales
                            </Link>
                        </div>
                    </NCollapseItem>
                </NCollapse>
            </li>
            <li class="w-full my-2 border-t-2 border-gray-200"></li>
            <li class="flex">
                <form @submit.prevent="logout">
                    <button
                        type="submit"
                        class="text-base text-gray-900 hover:text-primary font-normal rounded-lg flex items-center p-2 hover:bg-gray-100 group"
                    >
                        <Icon size="20">
                            <SignOutAlt
                                class="w-6 h-6 text-gray-500 flex-shrink-0 group-hover:text-primary transition duration-75"
                            />
                        </Icon>
                        <span class="ml-3">Salir</span>
                    </button>
                </form>
            </li>
        </ul>
    </NDrawerContent>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import {
    NDrawer,
    NDrawerContent,
    NIcon,
    NCollapse,
    NCollapseItem,
} from "naive-ui";
import { Icon } from "@vicons/utils";
import NavLink from "@/shared/NavLink.vue";
import {
    Truck,
    Key,
    MapPin,
    CalendarCheckRegular,
    LifeRingRegular,
    Building,
    Boxes,
    ChartPie,
    Store,
    User,
    ClipboardList,
    LifeRing,
    SignOutAlt,
    UserCog,
    Plus,
    TrafficLight,
    Buromobelexperte,
} from "@vicons/fa";

export default {
    name: "SidebarContent",
    components: {
        NavLink,
        Link,
        NDrawer,
        NDrawerContent,
        NIcon,
        Icon,
        Truck,
        Key,
        MapPin,
        CalendarCheckRegular,
        LifeRingRegular,
        Boxes,
        ChartPie,
        Store,
        Building,
        User,
        ClipboardList,
        LifeRing,
        SignOutAlt,
        UserCog,
        Plus,
        TrafficLight,
        Buromobelexperte,
        NCollapse,
        NCollapseItem,
    },
    methods: {
        renderIcon(icon) {
            return () => {
                return h(NIcon, null, {
                    default: () => h(icon),
                });
            };
        },
        logout() {
            this.$inertia.post(route("logout"));
        },
    },
};
</script>
